import React from 'react';

const WhyChoseUsPage = React.lazy(() => import('pages/WhyChoseUs/WhyChoseUsPage'));
const WhyChoseUsAddPage = React.lazy(() => import('pages/WhyChoseUs/WhyChoseUsAddPage'));

const WhyChoseUsRoute = [
  {
    path: '/why-choose-us',
    exact: true,
    name: 'Danh sách lý do chọn MAY',
    function: 'CMS_WHYCHOOSEUSS_VIEW',
    component: WhyChoseUsPage,
  },
  {
    path: '/why-choose-us/add',
    exact: true,
    name: 'Thêm mới lý do chọn MAY',
    function: 'CMS_WHYCHOOSEUSS_ADD',
    component: WhyChoseUsAddPage,
  },
  {
    path: '/why-choose-us/edit/:whyreason_id',
    exact: true,
    name: 'Chỉnh sửa lý do chọn MAY',
    function: 'CMS_WHYCHOOSEUSS_EDIT',
    component: WhyChoseUsAddPage,
  },
  {
    path: '/why-choose-us/detail/:whyreason_id',
    exact: true,
    name: 'Chi tiết lý do chọn MAY',
    function: 'CMS_WHYCHOOSEUSS_VIEW',
    component: WhyChoseUsAddPage,
  },
];

export default WhyChoseUsRoute;
